import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import ModalService from 'services/ModalService';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import { isMyProfileHelperFunc } from 'utils/helpers';

import EmpryGift from '../../../../../../images/profilePage/empry-gift.png';

import styles from './GiftShowcaseItem.css';


const AddNewGift = (props) => {
  const {
    clickHandler,
    handleBackClick,
    handleEmptyBackClick,
  } = props;

  const { profileName } = ProfileStore;
  const { user } = UserStore;

  const isMyProfile = isMyProfileHelperFunc(user, profileName);

  const addGift = useCallback(() => {
    if (isMyProfile) {
      return;
    }

    if (clickHandler) {
      clickHandler();
    } else {
      ModalService.showModal(ModalService.MODAL_KEYS.SEND_QUICK_GIFT_MODAL, {
        showClose: false,
        handleBackClick,
      });

      handleEmptyBackClick?.();
    }
  }, [
    clickHandler,
    handleEmptyBackClick,
    handleBackClick,
    isMyProfile,
  ]);

  return (
    <div
      className={styles.AddNewGift}
      onClick={addGift}
    >
      <div className={styles.giftWrapper}>
        <img
          alt="add new gift"
          className={styles.showcaseImg}
          src={EmpryGift}
        />
        {!isMyProfile && (
          <div className={styles.giftInfo}>
            <span className={styles.giftDetails}>
              {translate('v2profile.gifts.add.new.gift')}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

AddNewGift.propTypes = {
  clickHandler: PropTypes.func,
  handleBackClick: PropTypes.func,
  handleEmptyBackClick: PropTypes.func,
};

AddNewGift.defaultProps = {
  clickHandler: undefined,
  handleBackClick: undefined,
  handleEmptyBackClick: undefined,
};

export default observer(AddNewGift);
